export default {
    bindings: {
        'status': '@',
        'number': '@',
        'item': '=',
        'type': '@'
    },
    controller: 'statusBannerController',
    template: require('../views/statusBanner.html')
};



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/widget/components/statusBanner.component.js